// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3xZAv","author":"Table_author__1pgDY","authorImage":"Table_authorImage__2DUCa","unreadRow":"Table_unreadRow__3r439"};